import React from 'react'
import { useParams } from 'react-router-dom'

import { MXWidget } from '@divvy/odin.bank-manager'

import useDivvyUUID from '@sputnik/hooks/useDivvyUUID'

import { useGetMXWidgetUrl } from './GetMXWidgetUrl.gql'
import { MoneyMoverMXWidgetProps } from './types'

const MoneyMoverMXWidget = ({ isShowing, onClose, onBankAccountConnected }: MoneyMoverMXWidgetProps) => {
  const { appId } = useParams()

  const [companyDivvyUuid, { loading: isDivvyUUIDLoading }] = useDivvyUUID(appId)

  const { data, loading, error } = useGetMXWidgetUrl({
    variables: {
      companyId: companyDivvyUuid,
      mode: 'verification',
      isMobile: false,
    },
    skip: isDivvyUUIDLoading || !companyDivvyUuid,
    fetchPolicy: 'network-only',
  })

  return (
    <MXWidget
      isLoadingWidgetUrl={isDivvyUUIDLoading || loading}
      isShowing={isShowing}
      renderInsideModal={false}
      widgetUrl={data?.bankIntegrations?.widgetUrl}
      widgetUrlError={error}
      onBankAccountConnected={onBankAccountConnected}
      onClose={onClose}
    />
  )
}

export default MoneyMoverMXWidget
